export default __webpack_public_path__ + "static/media/sustainability-summit-and-awards-2023.51fc90d6.jpg";